import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { LoginService } from 'lps-navigation';
import { GoogleTagManagerService } from 'src/app/core/analytics/google-tag-manager.service';
import { EnvironmentService } from 'src/app/core/enviroment/environment.service';
import { Profile } from 'src/app/core/models/profile';
import { ProfileService } from 'src/app/profile-home/service/profile.service';
import { ContactEventTagBuilder } from 'src/app/shared/contact-event-tag.builder';
import { BrokerModalEditionComponent } from '../broker-modal-edition/broker-modal-edition.component';
import { OriginEnum } from './origin-enum';

@Component({
  selector: 'app-broker-header',
  templateUrl: './broker-header.component.html',
  styleUrls: ['./broker-header.component.scss']
})
export class BrokerHeaderComponent implements OnInit {

  @Input() profile: Profile;
  @ViewChild(BrokerModalEditionComponent) edition: BrokerModalEditionComponent;
  profileDefault = 'https://bucketsquadcrm.s3.amazonaws.com/default_images/profile_default.jpg';
  showModalLead: boolean;
  isWhatsapp: boolean;
  isMobile: boolean;
  loggedIn: boolean;
  defaultBiography: string;
  showModalCV: boolean;
  brokerCardProfile: boolean;
  displayShareDropdown: boolean;
  brokerUrl: string;

  constructor(
    private loginService: LoginService,
    private profileService: ProfileService,
    public environmentService: EnvironmentService,
    private googleTagService: GoogleTagManagerService
  ) {}
  
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setMobileDevice(event.target.innerWidth);
  }

  ngOnInit() {
    this.validateUserLoggedToShowEditButton();
    this.setMobileDevice(window.innerWidth);
    this.defaultBiography = this.profileService.getDefaultBiography(this.profile?.company);
    this.brokerCardProfile = this.environmentService.getEnvVar('feature_card_broker_profile');
    this.brokerUrl = `${this.environmentService.getEnvVar('base_url_portal')}associado/${this.profile.nickname}`;
  }

  setMobileDevice(event) {
    if (event <= 1024) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  validateUserLoggedToShowEditButton(): void {
    const logged = this.loginService.getAuthInformation()?.isUserLoggedIn();
    this.loggedIn = this.profile?.is_editable && logged;
  }

  openLeadModal(whatsapp = false) {
    this.isWhatsapp = whatsapp;
    this.showModalLead = true;
    this.sendAnalytics('', whatsapp, OriginEnum.CONTACT_BUTTON);
  }

  openEditModal() {
    this.edition.openEditModal();
  }

  openCard() {
    this.showModalCV = true;
    if (!this.isMobile) {
      document.body.style.paddingRight = '8px';
    }
    document.body.style.overflow = 'hidden';
  }

  closeCardModal(event: boolean) {
    this.showModalCV = event;
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  showInvalidCreciMessage(): boolean {
    return this.profile.is_valid_creci === false && this.isAgent();
  }

  isAgent(): boolean {
    const authInfo = this.loginService.getAuthInformation();
    return authInfo && authInfo.isUserLoggedIn() && authInfo.isAgent();
  } 

  public toggleShareDropdown() {
    this.displayShareDropdown = !this.displayShareDropdown;
  }

  get tooltipPosition(): string {
    return this.isMobile ? 'above' : 'after';
  }

  shareOnWhatsapp() {
    this.displayShareDropdown = false;
    this.sendAnalytics('whatsapp');
    window.open(`https://api.whatsapp.com/send?text=${this.brokerUrl}`, '_blank');
  }

  shareOnFacebook() {
    this.displayShareDropdown = false;
    const encodedURL = encodeURI(`${this.brokerUrl}`);
    this.sendAnalytics('facebook');
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodedURL}`, '_blank');
  }

  shareOnLinkedin() {
    this.displayShareDropdown = false;
    const encodedURL = encodeURI(`${this.brokerUrl}`);
    this.sendAnalytics('linkedin');
    window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${encodedURL}`, '_blank');
  }

  private sendAnalytics(eventLabel: string, isWhatsApp: boolean = false, origin: OriginEnum = OriginEnum.SHARE_BUTTON) {

    switch (origin) {
      case OriginEnum.CONTACT_BUTTON:  
        this.googleTagService.pushTag(new ContactEventTagBuilder(isWhatsApp)
            .fromAgentPage()
            .toContactClick()
            .build());
      break;
      
      case OriginEnum.SHARE_BUTTON: 
        this.googleTagService.pushTag(new ContactEventTagBuilder().fromAgentPage()
            .toShareClick()
            .withLabel(eventLabel)
            .build());
        
        break;
    }
    
  }
}
